import { useMemo } from "react";

import { IPart } from "../../../models/Part";
import checkEbayDisabled from "../../../utils/checkEbayDisabled";


export default function UnlistedReadyStatus({ part }: { part: IPart }) {

  const readyStatus = useMemo(() => {
    if (!part) {
      return { isDisabled: true, error: "No part found" };
    };

    // var defaults = defaultPartCategory.data?.data;
    var defaults = part.category?.partCategoryDefaults[0];

    var ready = checkEbayDisabled({ part, offer: part.offers[0], partCategoryDefault: defaults, ignoreListingTime: true });

    return ready;
  }, [part]);

  return (
    <div className="h-full flex flex-col w-40">
      {readyStatus?.isDisabled ? (
        <span className="text-red-500 text-sm text-center">{readyStatus?.error}</span>
      ) : (
        <div className="bg-green-200 text-green-500 px-3 text-xs mx-auto text-center rounded-full h-10 flex justify-center items-center ">
          <p>Ready</p>
        </div>
      )}
    </div>
  )
}